import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import * as html2pdf from 'html2pdf.js';
import { Location } from '@angular/common';
import { QuestionnarieService } from '../../../shared/services/questionnarie.service';
import { ToastrService } from 'ngx-toastr';
import { india_reads, eltai } from '../../../constant'

@Component({
  selector: 'ps-questionnarie-view-table',
  templateUrl: './questionnarie-view-table.component.html',
  styleUrls: ['./questionnarie-view-table.component.scss']
})
export class QuestionnarieViewTableComponent implements OnInit, AfterViewInit {
  @ViewChild('pdfContent', { static: false }) pdfContentRef!: ElementRef;
  public error: boolean = false;
  public questionnarieData: any = [];
  public studentId: any;
  public spinner: boolean = false;
  public questionIndex: any;
  public questionnarieID: any;
  public isEmail: any;
  public html: any;
  public institutionId: any;
  public institutionParamId: any;
  public india_reads: any;
  public eltai: any;
  public showData: any;
  public questionAnswer: any[] = [];
  public showButton: boolean = false;
  public activeTab: any;

  Array = Array;
  originalOrder = () => 0;

  constructor(private router: Router, private questionnarieService: QuestionnarieService, private toastr: ToastrService, private route: ActivatedRoute,
    private location: Location) {
    this.india_reads = india_reads.indiaReads;
    this.eltai = eltai.eltai;
  }

  ngOnInit(): void {
    // Get the value from the route for copy link:
    this.route.params.subscribe((param) => {
      this.studentId = param.studentId;
      this.questionIndex = param.index;
      this.questionnarieID = param.id;
      this.isEmail = param.isEmail;
      this.institutionParamId = param.institutionId;
    });
    this.route.queryParams.subscribe(params => {
      this.activeTab = params['activetab'];
    });
    this.showData = (this.activeTab === "mentor");
    this.getQuestionnarieByStudentById();
  }

  //To ensure the content is fully rendered before sending HTML
  ngAfterViewInit(): void {
    if (this.isEmail === 'sendEmail') {
      this.showButton = true;
    } else {
      this.showButton = false;
    }
  }

  // Send HTML content to backend for PDF generation
  async sendHtmlToBackend(): Promise<void> {
    const pdfContent = this.pdfContentRef?.nativeElement;
    this.spinner = true;

    if (!pdfContent) {
      console.error('PDF content element not found');
      this.spinner = false;
      this.toastr.error('PDF content element not found');
      return;
    }

    const html = pdfContent.outerHTML;
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const element = doc.body.firstElementChild as HTMLElement;

    if (!element) {
      console.error('Parsed element not found from HTML content');
      this.spinner = false;
      this.toastr.error('Invalid HTML content');
      return;
    }

    const clonedElement = element.cloneNode(true) as HTMLElement;
    const imgElements = clonedElement.querySelectorAll('img'); // This line is not used in the rest of the code, consider removing it
    let styles = Array.from(document.styleSheets)
      .map((sheet) => {
        try {
          return Array.from((sheet as CSSStyleSheet).cssRules)
            .map((rule) => rule.cssText)
            .join('\n');
        } catch (e) {
          return '';
        }
      })
      .join('\n');

    // Add custom CSS here
    styles += `
        .hide-in-pdf {
            display: none !important;
        }
    `;

    const htmlWithStyles = `
        <html>
            <head>
                <meta charset="UTF-8">
                <style>${styles}</style>
            </head>
            <body>
                ${clonedElement.outerHTML}
            </body>
        </html>
    `;

    const data = {
      content: htmlWithStyles,
      institutionId: this.institutionParamId,
      studentId: this.studentId
    };

    this.questionnarieService.checkPdf(data).subscribe({
      next: (res) => {
        this.spinner = false;
        this.router.navigate(["institute/questionnarie"]);
        this.toastr.success(res.message || 'PDF generated successfully');
      },
      error: (err) => {
        this.spinner = false;
        this.toastr.error('Failed to generate PDF');
      }
    });
  }

  // Get Questionarie Based on Student Id:
  getQuestionnarieByStudentById() {
    const data = {
      studentId: this.studentId,
      "page": 1,
      "itemsPerPage": ""
    };
    this.spinner = true; // Start spinner
    this.questionnarieService.getQuestionnarieByStudentById(data).subscribe(res => {
      this.spinner = false; // Stop spinner on response
      if (res.status) {
        this.questionnarieData = res.data.readingProfile.find(
          (item: any) => item.count == this.questionIndex);

        if (this.questionnarieData && this.questionnarieData.dynamicFields) {
          const rawFields = this.questionnarieData.dynamicFields;
          const processedQuestionAnswer: any[] = [];
          const otherKeysHandled: Set<string> = new Set();
          const otherOptions = ['others', 'Other', 'Others', 'other'];
          for (const key in rawFields) {
            if (rawFields.hasOwnProperty(key) && !key.endsWith('_other')) {
              const questionEntry = rawFields[key];
              let answer = questionEntry.answer;
              const otherKey = `${key}_other`;
              if (rawFields.hasOwnProperty(otherKey)) {
                const otherAnswer = rawFields[otherKey];
                if (Array.isArray(answer)) {
                  if (answer.some(val => otherOptions.includes(val))) {
                    const filteredAnswer = answer.filter(val => !otherOptions.includes(val));
                    answer = [...filteredAnswer, otherAnswer];
                  }
                } else if (typeof answer === 'string') {
                  if (otherOptions.includes(answer)) {
                    answer = `${otherAnswer}`;
                  }
                }
                otherKeysHandled.add(otherKey);
              }
              processedQuestionAnswer.push({
                question: questionEntry.question,
                answer: answer
              });
            }
          }
          for (const key in rawFields) {
            if (rawFields.hasOwnProperty(key) && key.endsWith('_other') && !otherKeysHandled.has(key)) {
              processedQuestionAnswer.push({
                question: `Additional detail for ${key.replace('_other', '')}`,
                answer: rawFields[key]
              });
            }
          }
          this.questionAnswer = processedQuestionAnswer;
        } else {
          this.questionAnswer = [];
        }
        if (this.questionAnswer.length === 0) {
          this.error = true;
        } else {
          this.error = false;
        }
      } else {
        this.toastr.error(res.message);
      }
    },
      (error) => {
        this.spinner = false; // Ensure spinner is stopped on error
        this.toastr.error('Error fetching questionnaire data.');
        console.error('Error:', error);
        this.error = true;
      });
  }

  // Helper to use in template for checking array type
  isArray(value: any): boolean {
    return Array.isArray(value);
  }

  // back
  back() {
    this.location.back();
  }

  // Download function for pdf
  async downloadPdf() {
    const element = document.getElementById('pdf-content');
    this.spinner = true;
    if (!element) {
      console.error('PDF content element not found');
      this.spinner = false;
      return;
    }

    // --- Pre-process: Hide elements and store original styles ---
    const originalStyles: { element: HTMLElement; property: string; value: string }[] = [];
    const elementsToHide = document.querySelectorAll('.hide-on-pdf, .no-print');
    elementsToHide.forEach(el => {
      const htmlEl = el as HTMLElement;
      originalStyles.push({ element: htmlEl, property: 'display', value: htmlEl.style.display });
      htmlEl.style.display = 'none';
    });

    const body = document.body;
    originalStyles.push({ element: body, property: 'overflow', value: body.style.overflow });
    body.style.overflow = 'hidden';

    const revertStyles = () => {
      originalStyles.forEach(item => {
        item.element.style[item.property as any] = item.value;
      });
      this.spinner = false;
    };

    try {
      await new Promise<void>((resolve, reject) => {
        setTimeout(() => {
          const options = {
            margin: [0.1, 0.1, 0.1, 0.1],
            filename: 'View QuestionnaireForm.pdf',
            image: { type: 'jpeg', quality: 0.98 },
            html2canvas: {
              scale: 1,
              letterRendering: true,
              useCORS: true,
              logging: false,
              allowTaint: true,
              onclone: (clonedDoc: Document) => {
                const style = clonedDoc.createElement('style');
                style.innerHTML = `
                * {
                    margin: 0 !important;
                    padding: 0 !important;
                    box-sizing: border-box !important;
                    line-height: 1.4 !important;
                    min-height: auto !important;
                    height: auto !important;
                    max-height: none !important;
                    overflow: visible !important;
                    word-wrap: normal !important;
                    hyphens: none !important;
                }
                @page {
                  size: auto;
                  margin: 0;
                }
                .hide-in-pdf{
                  display: none !important;
                }
                html, body {
                    background: #fff !important;
                    overflow: hidden !important;
                }
                .hide-on-pdf, .no-print, .loader, .btn-xl,
                .card-header, .card-header.h5.text-white.bg-primary {
                    display: none !important;
                    height: 0 !important;
                    width: 0 !important;
                    margin: 0 !important;
                    padding: 0 !important;
                    overflow: hidden !important;
                }
                .form-details-container {
                    padding: 1pc !important;
                    margin: 0px !important;
                    border: none !important;
                    box-shadow: none !important;
                    max-width: none !important;
                    width: 100% !important;
                    background-color: transparent !important;
                }
                .logo-img{
                    height: 50px !important;
                }
                .form-header {
                    margin-bottom: 5px !important;
                    padding-bottom: 0 !important;
                }
                .form-header h3 {
                    font-size: 20px !important;
                    border-bottom: none !important;
                    padding-bottom: 0 !important;
                    margin-bottom: 0 !important;
                }
                .questions-section {
                    margin: 0 !important;
                    padding: 0 !important;
                    width: 100% !important;
                }
                .question-row {
                    padding: 4px !important;
                    display: flex !important;
                    align-items: flex-start !important;
                    flex-wrap: wrap !important;
                    min-height: auto !important;
                    height: auto !important;
                    page-break-inside: avoid !important;
                    break-inside: avoid !important;
                }
                .form-group {
                    margin-bottom: 2px !important;
                }
                .form-heading {
                    margin-top:5px !important;
                    padding: 0 !important;
                    font-size: 18px !important;
                    page-break-after: avoid !important;
                }
                .question-label,
                .question-answer,
                .form-label,
                .form-separator,
                .form-value {
                    padding: 5px 8px !important;
                    background-color: transparent !important;
                    font-size: 14px !important;
                    word-break: keep-all !important;
                    overflow-wrap: normal !important;
                    white-space: pre-line !important;
                    flex-shrink: 1 !important;
                }
                .question-no {
                    padding: 5px 0px !important;
                    font-size: 14px !important;
                    border: 1px solid #00000054!important;
                }
                .question-answer{
                    text-align:justify !important;
                    min-width: 65% !important;
                }
                .question-sno {
                    text-wrap-mode: nowrap !important;
                    padding: 5px 0px !important;
                    width: 5%;
                }
                .form-label {
                    min-width: 200px !important;
                    white-space: normal !important;
                }
                .form-separator {
                    width: 10px !important;
                    text-align: center !important;
                }
                .form-value {
                    flex-grow: 1 !important;
                    min-width: 50% !important;
                }
               .question-block, 
                .question-row, 
                tr, td, th {
                  page-break-inside: avoid !important;
                  break-inside: avoid !important;
                  display: block !important;
                }
                .page-break-before {
                    page-break-before: always !important;
                }
                .page-break-after {
                    page-break-after: always !important;
                }
                table {
                    page-break-inside: auto !important;
                    break-inside: auto !important;
                    width: 100% !important;
                    border-collapse: collapse !important;
                }
                tr {
                    page-break-inside: avoid !important;
                    break-inside: avoid !important;
                    display: table-row !important;
                }
                td, th {
                    word-break: keep-all !important;
                    overflow-wrap: normal !important;
                    page-break-inside: avoid !important;
                    white-space: pre-line !important;
                    break-inside: avoid !important;
                    display: table-cell !important;
                    padding: 5px !important;
                }
                `;
                clonedDoc.head.appendChild(style);
                clonedDoc.querySelectorAll('.no-print, .hide-on-pdf').forEach(el => el.remove());
              }
            },
            jsPDF: {
              unit: 'in',
              format: 'a4',
              orientation: 'portrait'
            },
            pagebreak: {
              mode: ['avoid-all', 'css'],
              avoid: ['.question-block', '.question-row', 'tr', 'td'],
              before: '.page-break-before',
              after: '.page-break-after'
            }
          };

          html2pdf()
            .from(element)
            .set(options)
            .save()
            .then(() => resolve())
            .catch((err: any) => reject(err));
        }, 200);
      });
    } catch (err) {
      console.error("Error generating PDF:", err);
    } finally {
      revertStyles();
    }
  }

}